/*
 * Bozza di una lezione (lessonseditmultiple/:id, con ?ids= per le lezioni dello stesso gruppo): e' la
 * stessa pagina unica della nuova lezione (new.js), che con l'id carica la bozza, la aggiorna e permette
 * di eliminarla. Una lezione non in bozza si apre nella sua scheda (lessonsview).
 */
import { LessonsNew } from "./new";

export const LessonsEditMultiple = LessonsNew;
export default LessonsEditMultiple;
